import { graphql, useLazyLoadQuery } from "react-relay"
import { useDePreparationAdditionalInformationQuery as useDePreparationAdditionalInformationQueryType } from "@/modules/patients/detail/medication/de/services/__generated__/useDePreparationAdditionalInformationQuery.graphql"

const query = graphql`
  query useDePreparationAdditionalInformationQuery($pharmaceuticalCentralNumber: String!) {
    de_preparationSpecialistInformation(pharmaceuticalCentralNumber: $pharmaceuticalCentralNumber) {
      name
      informationTexts {
        textId: id
        title
        decodedText
      }
    }
    de_preparationInformationLetter(pharmaceuticalCentralNumber: $pharmaceuticalCentralNumber) {
      letterNumber
      letterList {
        document
      }
    }
  }
`

export const useDePreparationAdditionalInformationQuery = (pharmaceuticalCentralNumber: string) => {
  const { de_preparationSpecialistInformation, de_preparationInformationLetter } =
    useLazyLoadQuery<useDePreparationAdditionalInformationQueryType>(query, {
      pharmaceuticalCentralNumber,
    })

  return {
    specialistInformation: de_preparationSpecialistInformation,
    letterInformation: de_preparationInformationLetter,
  }
}
